/** @file INFO warnings for unused images and attachments nothing can show; nothing is pruned. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Warning } from '@pose2d/format/types';

/** Images no attachment or reference uses (kept in the atlas, R2-08); unskinned attachments without a handle. */
export function pruneWarnings(doc: Doc): Warning[] {
  const out: Warning[] = [];
  const usedImages = new Set([...Object.values(doc.attachments), ...Object.values(doc.references)].map((x) => x.image));
  for (const [id, image] of entriesByName(doc.images)) {
    if (usedImages.has(id)) continue;
    out.push({ code: 'INFO', message: `image "${image.name}" is unused`, params: { image: image.name }, path: `images.${id}` });
  }
  const skinned = new Set(Object.values(doc.skins).flatMap((s) => s.entries.map((e) => e.attachment)));
  for (const [id, att] of entriesByName(doc.attachments)) {
    if (skinned.has(id) || att.handle !== undefined) continue;
    out.push({ code: 'INFO', message: `attachment "${att.name}" is in no skin and has no handle, so nothing can show it`, params: { attachment: att.name }, path: `attachments.${id}` });
  }
  return out;
}
